import { T, Translate } from '../i18n';
import { m, type MChild, type MithrilVNode } from '../mithril';
import { classNames } from '../util/classnames';
import { addStyles, DefaultTheme } from './theme';

const CSS = {
	wrapper: 'c-ProFeatureTooltip',
	stretch: 'c-ProFeatureTooltip--stretch',
	bubble: 'c-ProFeatureTooltip__bubble',
	below: 'c-ProFeatureTooltip__bubble--below',
};

// Sit above page chrome but below modals/popovers (which own MODAL_Z_INDEX and up).
const TOOLTIP_Z_INDEX = 1000;

addStyles({
	[CSS.wrapper]: {
		position: 'relative',
		display: 'inline-flex',
	},
	[CSS.stretch]: {
		display: 'flex',
		width: '100%',
	},
	[CSS.bubble]: {
		position: 'absolute',
		left: '50%',
		bottom: '100%',
		transform: 'translateX(-50%)',
		'margin-bottom': DefaultTheme.space(1),
		padding: `${DefaultTheme.space(1)} ${DefaultTheme.space(2)}`,
		'border-radius': '4px',
		background: DefaultTheme.background.mediumGrey,
		color: DefaultTheme.font.color.white,
		'font-size': '12px',
		'line-height': 1.4,
		'white-space': 'nowrap',
		'box-shadow': DefaultTheme.shadow.box.dp2,
		'z-index': TOOLTIP_Z_INDEX,
		opacity: 0,
		'pointer-events': 'none',
		transition: 'opacity 150ms ease',
	},
	[`${CSS.wrapper}:hover .${CSS.bubble}`]: {
		opacity: 1,
	},
	[CSS.below]: {
		bottom: 'auto',
		top: '100%',
		'margin-bottom': 0,
		'margin-top': DefaultTheme.space(1),
	},
});

export interface ProFeatureTooltipAttrs {
	children: MChild | MChild[];
	message?: string;
	position?: 'above' | 'below';
	stretch?: boolean;
}

export const ProFeatureTooltip = {
	view(attrs: ProFeatureTooltipAttrs): MithrilVNode {
		const message = attrs.message ?? Translate(T.PRO_ONLY_FEATURE);
		const children = Array.isArray(attrs.children) ? attrs.children : [attrs.children];
		return m('span', { className: classNames(CSS.wrapper, { [CSS.stretch]: !!attrs.stretch }) }, [
			...children,
			m(
				'span',
				{ className: classNames(CSS.bubble, { [CSS.below]: attrs.position === 'below' }), role: 'tooltip' },
				message
			),
		]);
	},
};
